import type { PropsWithChildren, ReactElement } from "react";
import { useState } from "react";

import { Collapsible } from "@similarweb/ui-components";

type TriggerProps = {
    isExpanded: boolean;
    onClick(): void;
};

type Props = PropsWithChildren<{
    className?: string;
    id: string;
    defaultIsExpanded?: boolean;
    renderTrigger: (props: TriggerProps) => ReactElement;
    externalIsExpanded?: boolean;
    onToggle?: () => void;
}>;

const CollapsibleSection = ({
    className,
    id,
    defaultIsExpanded = false,
    externalIsExpanded,
    onToggle,
    children,
    renderTrigger: Trigger,
}: Props) => {
    const [isExpanded, setIsExpanded] = useState(defaultIsExpanded);
    const effectiveIsExpanded = externalIsExpanded !== undefined ? externalIsExpanded : isExpanded;

    const handleTriggerClick = (): void => {
        if (onToggle) {
            onToggle();
        } else {
            setIsExpanded(!isExpanded);
        }
    };

    return (
        <section
            className={className}
            data-automation="collapsible-section"
            data-automation-section-id={id}
        >
            <Trigger
                isExpanded={effectiveIsExpanded}
                onClick={handleTriggerClick}
            />
            <Collapsible isActive={effectiveIsExpanded}>{children}</Collapsible>
        </section>
    );
};

export default CollapsibleSection;
